import m from "../../geodata/es2015/bonaireSintEustatiusSabaHigh";
window.am4geodata_bonaireSintEustatiusSabaHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/bonaireSintEustatiusSabaHigh.js
// module id = null
// module chunks = 